import { render, staticRenderFns } from "./DetailsViewPage.vue?vue&type=template&id=54482898&scoped=true&"
import script from "./DetailsViewPage.vue?vue&type=script&lang=js&"
export * from "./DetailsViewPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailsViewPage.vue?vue&type=style&index=0&id=54482898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54482898",
  null
  
)

export default component.exports